import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LogCreateForm } from "./components/LogCreateForm";

export function NewLogPage() {
  return (
    <Page title="New Log">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogCreateForm />
      </Container>
    </Page>
  );
}
